import { ClientStatus } from "@shared/types";

export const PORTFOLIO_DATA_CLIENT_HEADER = "client";
export const PORTFOLIO_DATA_CLIENT_ID_HEADER = "client_id";
export const PORTFOLIO_DATA_EXCHANGE_HEADER = "exchange";
export const PORTFOLIO_DATA_CLIENTS_HEADER = "clients";
export const PORTFOLIO_DATA_EXCHANGES_HEADER = "exchanges";
export const PORTFOLIO_DATA_CLIENT_IDS_HEADER = "client_ids";

export const INACTIVE_ACCOUNT_STATUSES = new Set([
  ClientStatus.DEACTIVATED_BY_USER,
  ClientStatus.DEACTIVATED_BY_SYSTEM,
  ClientStatus.DELETED_BY_SUB_USER,
  ClientStatus.DELETED_BY_ASSET_MANAGER,
]);

export const DEMO_ACCOUNT_DEFAULT_INITIAL_FUNDS = 100000;
export const DEMO_ACCOUNT_INITIAL_FUNDS_RANGE = [100, 1000000];

export const ASSET_NUMBER_FIELDS = [
  "quantity",
  "available_quantity",
  "total_in_btc",
  "total_in_usd",
  "available_in_btc",
  "available_in_usd",
  "total_ratio",
  "exchange_ratio",
] as const;
